import { AppListing } from "../../../components/AppListing/Listing.view";
import { useGetLettersQuery } from "../../../services/lettersOrdersService";
import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
// import { orderCols } from "../../letters_orders/lettersOrders.data";
import DialogCover from "../DialogCover";
import { formattedDate } from "../../../helper";

function LetterOrderListing({ shareDataDetail,selectedChat }) {

  const { data: lettersData, isLoading: loadingLetters } = useGetLettersQuery({
    pid: selectedChat?.pid,
  });
  const filterLetterData = useMemo(() => {
    return lettersData?.filter((item, k) => item.is_signed != 0);
  }, [lettersData]);

  return (
    <DialogCover title="Letters/Orders" {...shareDataDetail}>
      <>
        <AppListing
          listData={filterLetterData}
          selection={true}
          cols={orderCols?.map((v, k) => ({
            ...v,
            title: v?.label,
            getData: v?.getVal,
          }))}
          toggleSelectItem={(data) => {
            shareDataDetail?.setSelectedFiles(data);
          }}
        />
      </>
    </DialogCover>
  );
}

export default LetterOrderListing;
const orderCols = [
  {
    label: "Letter",
    key: "template_name",
    widthCss: "min-w-[190px] mr-2 flex-1 break-all",
    colWidth: "2",
  },
  { label: "type", key: "template_type",colWidth: "1", },
  { label: "Created By", key: "created_by",colWidth: "2", },
  {
    label: "Created On",
    colWidth: "2",
    getVal: (item) => formattedDate(item.created, "MM/DD/YYYY hh:mm A",),
  },
  { label: "Print Count", key: "" ,colWidth: "1",},
  { label: "Printed On", key: "printed_on" ,colWidth: "2",},
  { label: "Printed By", key: "printed_by",colWidth: "1", },
  {
    label: "Status",
    getVal: (item) => (item.is_signed == 0 ? "Draft" : "Signed"),
    colWidth: "1",
  },
  //   { label: "Actions" },
];


